import React, { useEffect, useState } from 'react'
// Component
import { EmptyText, WordBreak } from '../../../../../components/Common/CellText'
// Styled Component
// Ant design
import { Menu, message } from 'antd'
// Other
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'

const ProposalDetailOther = props => {
  const {
    proposalStore,
    loadingAnimationStore,
    commonStore,
    proposalId,
    fileStore,
    history,
    selectPeopleStore,
  } = props

  const { otherDetail } = proposalStore

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await proposalStore.getOtherDetail(proposalId)
      } catch (err) {
        history.push('/proposal')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()

    return () => {
      selectPeopleStore.clearSelected()
      proposalStore.clearOtherDetail()
    }
  }, [proposalId])

  return (
    <>
      {otherDetail?.reason ? (
        WordBreak(otherDetail?.reason, true)
      ) : (
        <EmptyText>Không có nội dung</EmptyText>
      )}

      {/* <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() => setIsVisibleSelectUserDepartmentPopup(false)}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      /> */}
    </>
  )
}

ProposalDetailOther.propTypes = {}

export default withRouter(
  inject(
    'proposalStore',
    'commonStore',
    'loadingAnimationStore',
    'fileStore',
    'selectPeopleStore'
  )(observer(ProposalDetailOther))
)
